module.exports = __webpack_public_path__ + "img/adhka-yx1zn.003.309244c9.jpeg";